module.exports = __webpack_public_path__ + "img/DE00343.7f86ad4e.png";